export default "__VITE_ASSET__3c34b9f8__"